// extracted by mini-css-extract-plugin
export var footer = "_o6-5";
export var fulfillmentInput = "_o6-0";
export var shipDateInput = "_o6-1";
export var shipmentModal = "_o6-2";
export var shipmentModalContent = "_o6-3";
export var tableContainer = "_o6-4";